<template>
  <div class="container-fluid">
    <!-- 본인 인증하기   -->
    <div class="row join-page" v-if="confirm === false">
      <div class="col-12 p-0" v-if="joinUrl === 'atl'">
        <!-- 240206 아틀란 이벤트 -->
        <img src="@/assets/event/20250519_ATL_V13.png" alt="아틀란_이벤트_이미지"/>
      </div>
      <div class="col-12 p-0" v-else>
        <img v-if="joinUrl === 'mancharo'" src="@/assets/main_mancharo.jpg">
        <img v-else-if="image_code === '102108'" src="@/assets/event/20250519_HMM_V1.png">
        <img v-else-if="image_code === '103108'" src="@/assets/event/20250519_MAN_V2.png">
        <img v-else src="@/assets/main_hmm.jpg">
      </div>
      <div class="mt-2 p-0">
        <div class="text-start mt-2" v-if="joinUrl !== 'atl'">
          <dt class="fs-title">본인인증 하기</dt>
          <dd class="fs-nav pb-2">{{ homeName }} 회원가입을 위해서는<br/>본인인증이 필요합니다<br/>본인인증 하기 버튼을 클릭하세요.</dd>
          <div class="d-flex flex-column align-items-center mt-2">
            <div class="verify-icon" @click="showConfirm"><img class="login-btn" src="../assets/sns/hmm_check_png.png"
                                                               alt="본인인증 하기 버튼"/></div>
            <div class="mt-1 verify-icon" @click="loginWithKakao"><img class="login-btn"
                                                                       src="../assets/sns/kakao_check_png.png"
                                                                       alt="카카오 로그인 버튼"/></div>
          </div>
          <!--          <div @click="doNaverLogin" class="naver-css d-flex justify-content-center"><img class="login-btn" src="../assets/sns/btnG_완성형.png" alt="네이버 로그인 버튼"/></div>-->
        </div>
        <div class="d-flex flex-column align-items-center mt-2" v-else>
          <div class="verify-icon" @click="showConfirm"><img class="login-btn" src="../assets/sns/hmm_check_png.png"
                                                             alt="본인인증 하기 버튼"/></div>
          <!-- 카카오 API -->
          <a id="kakao-login-btn" @click="loginWithKakao">
            <div class="mt-1 verify-icon" @click="loginWithKakao"><img class="login-btn"
                                                                       src="../assets/sns/kakao_check_png.png"
                                                                       alt="카카오 로그인 버튼"/></div>
          </a>
          <!-- 네이버 API -->
          <!--          <div id="naver_id_login">-->
          <!--            <a id="naver-login-btn" @click="doNaverLogin">-->
          <!--              <div class="naver-css"><img src="../assets/sns/btnG_완성형.png" alt="네이버 로그인 버튼"/></div>-->
          <!--            </a>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <!-- 본인인증 완료 -->
    <div v-if="confirm === true">
      <dl class="text-start">
        <dt class="fs-3">본인 인증이<br/>완료되었습니다 :)</dt>
        <dd>아래 정보를 확인해주세요.</dd>
      </dl>
      <div class="card">
        <div class="card-body text-start">
          <div class="row gap-1">
            <div class="row">
              <label for="inputEmail3" class="col-4 col-form-label">이름</label>
              <div class="col-4 px-0">
                <input type="text" class="form-control" id="inputEmail3" :value="userInfo.name" readonly>
              </div>
              <div class="col-4 px-0">
                <input type="text" class="form-control" id="inputEmail4" :value="nationalName" readonly>
              </div>
            </div>
            <div class="row">
              <label for="inputPassword3" class="col-4 col-form-label">생년월일</label>
              <div class="col-4 px-0">
                <input type="text" class="form-control" id="inputPassword3" :value="userInfo.birth" readonly>
              </div>
              <div class="col-4 px-0">
                <div class="btn-group w-100" role="group" aria-label="Basic radio toggle button group">
                  <button class="btn gender-button" :class="userGender === '1' ? 'active' : 'non-active'">남</button>
                  <button class="btn gender-button" :class="userGender === '0' ? 'active' : 'non-active'">여</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer mt-3 d-flex gap-1 justify-content-end">
        <button class="btn btn-primary col-12 rounded-pill" @click="moveAfter">다음</button>
      </footer>
    </div>
  </div>
</template>

<script>
import config from '../_config.js';
import {isSocialLogin} from "@/assets/js/SocialLoginComposables";

/**
 * 간편회원가입 - 본인인증 페이지
 */

export default {
  name: "MobileValidation",
  data() {
    return {
      currentPageData: {
        page: '',
      },
      userInfo: {
        birth: '850812',
        gender: '1',
        name: '홍길동',
        national: '1',
        mobile: '01012341234',
      },
      selectedGender: 0,
      nationalName: '',
      confirm: false,
      homeName: '',
      joinUrl: '',
      test_mode: false,
      image_code: '',
    }
  },
  computed: {
    userGender() {
      return this.selectedGender;
    },
  },
  mounted() {
    this.joinUrl = this.$store.getters.getJoinUrl;
    this.image_code = sessionStorage.getItem("now-code");
    console.log("image_code : ", this.image_code);
    this.test_mode = this.$store.getters.getTestEnv;
    this.homeName = this.joinUrl === 'mancharo' ? '만차로' : '화물맨';
  },
  methods: {
    async moveAfter() {
      //테스트 모드가 아닐 경우 실행
      const nextPageInfo = await this.$http.post('/api/user/reg/mmn/v2', this.userInfo)
          .catch(err => {
            this.$swal.fire('에러 : ' + err.message);
            this.$router.push({ path: '/' });
          });

      if (nextPageInfo === undefined) {
        await this.$router.push({ path: '/' });
        return;
      }

      if (nextPageInfo.data.code !== 200) {
        await this.$swal.fire(`회원님은 서비스 \n이용이력이 있으신 회원이십니다.\n콜센터를 통해서 \n가입신청을 진행하십시오.`);
        await this.$router.push({ path: '/' });
        return;
      }
      /*
      아틀란, 기타 추가정보를 입력해야한는 경우
       */
      const response_data = nextPageInfo.data.data;
      const router_view = response_data.router_view;
      const user_seq = response_data.user_seq;

      if (router_view === 'UNKNOWN_MEMBER') {
        console.log("신규가입 대상자입니다.")
        //화물맨 기본 로직
        const join_path = sessionStorage.getItem("grade-code");

        if (join_path === '8' || join_path === '11') {
          this.currentPageData.page = 'hmm';
        } else if (join_path === '12') {
          this.currentPageData.page = 'atl';
        } else if (join_path === '100208') {
          this.currentPageData.page = 'event20';
        } else {
          // 끝자리 2자리에서 0 제거
          let modifiedPath = join_path;
          if (modifiedPath.length >= 2) {
            const lastTwo = modifiedPath.slice(-2); // 끝 2자리 추출
            if (lastTwo.includes('0')) {
              modifiedPath = modifiedPath.replace(/0+$/, ''); // 끝에서 0 제거 (연속된 0도 처리)
            }
          }

          // 수정된 값으로 기존 조건 적용
          if (modifiedPath === '8' || modifiedPath === '11') {
            this.currentPageData.page = 'hmm';
          } else if (modifiedPath === '12') {
            this.currentPageData.page = 'atl';
          } else {
            this.currentPageData.page = 'hmm';
          }
        }
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$emit('current-page',this.currentPageData);
        return;
      }
      this.$store.commit('setUserSeq', user_seq);

      // 신규 가입 또는 정보 미입력 경우
      if (router_view === 'INFO') {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      // 가입 완료되었으나 첨부 서류 미비한 경우
      if (router_view === 'PAPER') {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-paper';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      // PAPER와 INFO가 같이 포함된 경우
      if (router_view.includes("PAPER") && router_view.includes("INFO")) {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
      }
    },
    showConfirm() {
      if (this.test_mode) {
        //테스트용 성별 값
        this.confirm = true;
        this.selectedGender = '1';
        this.nationalName = '내국인';
        this.userInfo.mobile = this.generatedPhoneNumber();
        this.$store.commit('setMemberInfo', this.userInfo);
        return;
      }
      //본인인증
      window.addEventListener("message", this.receiveMessage, false);
      window.open('https://auth.bgsoft.kr:8443/nice_module/chk', '_blank', 'width=500,height=600');
    },
    async receiveMessage(response) {
      const name = response.data.name;
      const mobile = response.data.phone;
      const birth = response.data.birth;
      const national = response.data.national;
      const gender = response.data.gender;

      if (this.isEmpty(name) || this.isEmpty(mobile)) {
        await this.$swal.fire('오류가 발생했습니다.');
        return;
      }

      this.userInfo.name = name;
      this.userInfo.mobile = mobile;
      this.userInfo.birth = birth;
      this.userInfo.national = national;
      this.userInfo.gender = this.changeGenderCode(national, gender, birth);

      this.selectedGender = gender;
      this.nationalName = this.getNationality(national);

      // 본인인증 완료되었다.
      try {
        // 2. 사용자 휴대전화 정보 확인
        if (!this.userInfo.mobile) {
          await this.alertAndRedirect('휴대전화 정보가 없습니다.');
          return;
        }

        // 3. 다음 페이지 진행 처리 (테스트 모드가 아닐 경우)
        /*
        가입경로는 확인할 수 있다.
        가입경로에 따라 보여줘야하는 화면이 다르다.

        8,11,12라면
         */
        await this.processNextStep();
      } catch (ex) {
        console.error("예외 발생:", ex);
      }
    },
    // 다음 단계 진행 (회원가입/정보 입력 관련)
    async processNextStep() {
      const nextPageInfo = await this.$http.post('/api/user/reg/mmn/v2', this.userInfo)
          .catch(err => {
            this.$swal.fire('에러: ' + err.message);
          });
      if (!nextPageInfo) return;

      if (nextPageInfo.data.code !== 200) {
        await this.$swal.fire(nextPageInfo.data.message);
        await this.$router.push({ path: '/' });
        return;
      }

      await this.handlePageRouting(nextPageInfo.data.data, nextPageInfo.data.message);
    },
    async processAutoJoinMember() {
      const memberCreateParam = {
        act_app: 101,
        name: this.userInfo.name,
        mobile: this.userInfo.mobile,
        birthday: this.userInfo.birth,
        corp_ceo_personno1: this.userInfo.birth.length === 8 ? this.userInfo.birth.substring(2, 8) : this.userInfo.birth,
        corp_ceo_personno2: "",
        corp_ceo_personno_tmp: "",
        address1: "",
        address2: "",
        zipcode: "",
        user_carnum: "",
        user_cartype: "카고",
        user_cartypecode: 1,
        user_carsize: "25톤",
        user_carsizecode: 2500,
        group_code: null,
        grade_code: sessionStorage.getItem("grade-code"),
        corp_num: "",
        email: "",
        taxemail: "",
        rbank_type: "",
        rbank_typecode: "",
        rbank_num: "",
        rbank_username: "",
        img_sign: "",
        img_usersign: "",
        point_used_agree: `N`,
        phone_check: 1,
        car_check: 0,
        corp_check: 0,
        rbank_check: 0,
        rbank_typecode_num: null,
      };

      try {
        const response = await this.$http.post('/api/user/add/cw', memberCreateParam);
        if (response.data.error === false) {
          const user_seq = response.data.data.seq;
          this.$store.commit('setUserSeq', user_seq);
          this.$store.commit('setGradeCode', memberCreateParam.grade_code);
          if (isSocialLogin()) {
            const socialCorpName = this.$store.getters.getSocialCorpName;
            const socialId = this.$store.getters.getSocialId;
            await this.$http.post('/api/simplejoin/social/id', {
              user_seq,
              provider_corp_name: socialCorpName,
              social_login_id: socialId,
              mobile: memberCreateParam.mobile,
              type: 1 // 차주: 1, 화주: 2
            });
          }
        } else {
          await this.$swal.fire(response.data.message);
        }
      } catch (error) {
        await this.$swal.fire(error.response.data.message);
      }
    },
    // 페이지 라우팅 처리: 가입 경로에 따라 화면 분기
    async handlePageRouting(pageRouteInfo) {
      const router_view = pageRouteInfo.router_view;
      const user_seq = pageRouteInfo.user_seq;
      if (router_view === 'UNKNOWN_MEMBER') {
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        if (sessionStorage.getItem("grade-code") === '100208') {
          await this.processAutoJoinMember();
          this.currentPageData.page = 'member-final';
          this.$emit('current-page', this.currentPageData);
          return;
        }
        this.confirm = true;
      }
      this.$store.commit('setUserSeq', user_seq);
      // 신규 가입 또는 정보 미입력 경우
      if (router_view === 'INFO') {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      // 가입 완료되었으나 첨부 서류 미비한 경우
      if (router_view === 'PAPER') {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-paper';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      // PAPER와 INFO가 같이 포함된 경우
      if (router_view.includes("PAPER") && router_view.includes("INFO")) {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
      }
    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
    changeGenderCode(national, gender, birth) {
      if (national == "0") {  //내국인
        if (gender == "1") { //남성(1)
          if (birth[0] == "2") {  //2000년대생
            return "3";
          } else {
            return "1";
          }
        } else {              //여성(0)
          if (birth[0] == "2") {  //2000년대생
            return "4";
          } else {
            return "2";
          }
        }
      } else {  //외국인
        if (gender == "1") { //남성(1)
          if (birth[0] == "2") {  //2000년대생
            return "7";
          } else {
            return "5";
          }
        } else {              //여성(0)
          if (birth[0] == "2") {  //2000년대생
            return "8";
          } else {
            return "6";
          }
        }
      }
    },
    getNationality(national) {
      return national == '0' ? '내국인' : '외국인';
    },
    generatedPhoneNumber() {
      let min = Math.pow(10, 10);
      let max = Math.pow(10, 11) - 1;
      // Math.random()을 사용하여 랜덤 숫자 생성 후 11자리로 만듭니다.
      let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

      return randomNumber.toString(); // 문자열로 반환
    },
    loginWithKakao() {
      window.Kakao.Auth.authorize({
        redirectUri: `${config.apiRoot}api/kakao/${this.$store.getters.getJoinUrl}`,
        // redirectUri: `http://222.231.9.248:8080/api/kakao/${this.$store.getters.getJoinUrl}`,
      });
    },
    // loginWithNaver(){
    //   const client_id = 'coXCcfHCPlady8NZB1H7';
    //   const redirectUrl = 'http://192.168.0.213:9090/api/naver';
    //   const domain = "http://192.168.0.213:8080/";
    //   var naver_id_login = new window.naver_id_login(client_id, redirectUrl);
    //   var state = naver_id_login.getUniqState();
    //   naver_id_login.setButton("white", 2,40);
    //   naver_id_login.setDomain(domain);
    //   naver_id_login.setState(state);
    //   naver_id_login.setPopup();
    //   naver_id_login.init_naver_id_login();
    // },
    doNaverLogin() {
      const client_id = 'coXCcfHCPlady8NZB1H7';
      const redirectUrl = 'http://192.168.0.213:9090/api/naver/' + this.$store.getters.getJoinUrl;
      // const redirectUrl = 'http://192.168.0.213:8080/#/naver/redirect' + this.$store.getters.getJoinUrl;
      const state = encodeURI(redirectUrl);
      const url = 'https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=' +
          client_id +
          '&redirect_uri=' +
          redirectUrl +
          `&state=${state}`;
      //
      // this.showSocialLoginPopup(url)
      window.location.href = url;
    },
    showSocialLoginPopup(url) {
      const popupHeight = '500'
      const popupWidth = '500'
      let popupOptions = 'height=--popupHeight--,width=--popupWidth--,left=--popupX--,top=--popupY--,scrollbars=yes,resizable=yes'

      popupOptions = popupOptions.replace('--popupHeight--', popupHeight)
      popupOptions = popupOptions.replace('--popupWidth--', popupWidth)

      this.openPopup(url, popupOptions)
      return false
    },
    openPopup(url, options) {
      window.open(
          url,
          '_blank',
          options
      )
    },
  },
}
</script>

<style scoped>
/* 스타일 수정 */
.gender-button {
  color: #333;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
}

.gender-button.active {
  background-color: #4fb1ec;
  border-color: #4fb1ec;
  color: #fff;
  pointer-events: none;
}

.gender-button.non-active {
  background-color: #ccc; /* 회색 배경색으로 변경 */
  color: #fff; /* 회색 텍스트색으로 변경 */
  pointer-events: none;
}

img {
  max-width: 100%;
}

.naver-css {
  background-color: #03c75a !important;
  border-radius: 12px
}

.kakao-css {
  background-color: #FEE500;
  border-radius: 12px
}

.login-btn {
  //width: 100%;
  //height: 65px;
}

.verify-icon {
  width: 100%;
  max-width: 600px;
  max-height: 65px;
  min-height: 50px;
}

.join-page {
  max-width: 320px;
  max-height: 750px;
  margin: auto;
}
</style>